import { compileStatDefinition } from './compileStatDefinition';

const BattingStats = compileStatDefinition({
    GP: { editable: true, isTestStat: true },
    AB: { editable: true },
    '1B': { editable: true },
    '2B': { editable: true },
    '3B': { editable: true },
    HR: { editable: true },
    RBI: { editable: true },
    R: { editable: true },
    BB: { editable: true },
    SO: { editable: true },
    'K-L': { editable: true },
    HBP: { editable: true },
    SAC: { editable: true },
    SF: { editable: true },
    ROE: { editable: true },
    FC: { editable: true },
    SB: { editable: true },
    CS: { editable: true },
    PIK: { editable: true },
    QAB: { editable: true },
    HHB: { editable: true },
    LD: { editable: true },
    FB: { editable: true },
    GB: { editable: true },
    LOB: { editable: true },
    '2OUTRBI': { editable: true },
    PS: { editable: true },
    '2S+3': { editable: true },
    '6+': { editable: true },
    GIDP: { editable: true },
    CI: { editable: true },
});

const PitchingStats = compileStatDefinition({
    'GP:P': { editable: true, isTestStat: true },
    IP: { editable: true },
    GS: { editable: true },
    BF: { editable: true },
    '#P': { editable: true },
    TB: { editable: true },
    TS: { editable: true },
    H: { editable: true },
    R: { editable: true },
    ER: { editable: true },
    BB: { editable: true },
    SO: { editable: true },
    'K-L': { editable: true },
    HBP: { editable: true },
    LOB: { editable: true },
    BK: { editable: true },
    PIK: { editable: true },
    CS: { editable: true },
    SB: { editable: true },
    WP: { editable: true },
    W: { editable: true },
    L: { editable: true },
    SV: { editable: true },
    BS: { editable: true },
    'LBFP#': { editable: true },
    '<3': { editable: true },
    LOO: { editable: true },
    '1ST2OUT': { editable: true },
    '123INN': { editable: true },
    '<13': { editable: true },
    '0BBINN': { editable: true },
    BBS: { editable: true },
    LOBB: { editable: true },
    LOBBS: { editable: true },
    SM: { editable: true },
    SW: { editable: true },
    WHB: { editable: true },
    HHB: { editable: true },
    GO: { editable: true },
    AO: { editable: true },
    LD: { editable: true },
    FB: { editable: true },
    GB: { editable: true },
});

const FieldingStats = compileStatDefinition({
    'GP:F': { editable: true, isTestStat: true },
    A: { editable: true },
    PO: { editable: true },
    E: { editable: true },
    DP: { editable: true },
    TP: { editable: true },
});

const CatchingStats = compileStatDefinition({
    'GP:C': { editable: true, isTestStat: true },
    INN: { editable: true },
    PB: { editable: true },
    SB: { editable: true },
    CS: { editable: true },
    PIK: { editable: true },
    CI: { editable: true },
});

export const BatsStats = {
    batting: BattingStats,
    pitching: PitchingStats,
    fielding: FieldingStats,
    catching: CatchingStats,
};
export type DerivedBatsStatType = keyof typeof BatsStats;
